export const styles = {
  root: {
    padding: { md: "15px 20px", xs: "15px 5px" },

    background: "#F8F8F8",
    borderRadius: "6px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    minHeight: "60vh",
    flexGrow: 1,
  },

  count: {
    color: "#909090",
    fontWeight: "500",
  },
  img: {
    width: "100%",
    height: "75vh",
    objectFit: "contain",
    borderRadius: "20px",
  },
  closeIcon: {
    position: "absolute",
    top: 5,
    right: 5,
    zIndex: 1000,
    background: "#fff",
  },
  textGrey: {
    color: "#909090",
  },
  playBtn: {
    position: "absolute",
    bottom: 10,
    right: 10,
    background: "#fff",
    padding: "10px 12px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
  },
  carousel: {
    width: "100%",
    minHeight: "75vh",
    height: "auto",
  },
  ul: {
    marginTop: 2,
    ".MuiPaginationItem-root ": {
      color: "#86D1BB",
      fontWeight: "bold",
      background: "#E7F6F1",
      border: "1.5px solid #86D1BB",
    },
    ".Mui-selected": {
      fontWeight: "bold",
      background: "#86D1BB",
      border: "1.5px solid #86D1BB",
    },
    ".css-12c6k7e.Mui-selected ,.css-91qxov-MuiButtonBase-root-MuiPaginationItem-root.Mui-selected":
      {
        color: "#fff",
      },

    display: "flex",
    justifyContent: "flex-end",
    my: 2,
  },
};
